
import React from 'react';
import {
  loadAllUsers,
  loadWlfAUM,
  loadProxyOnboarding,
  loadBillingDetail,
  getLPOAItems
} from "../SA_UserPortfolios/actions";
import { sprintf } from 'sprintf-js';
import { getRGB } from "../../../lib/color";
import BannerMenu from "../BannerMenu";
import PortfolioDashboard from "../PortfolioDashboard";
import { DEVICE_WIDTH } from "../../../lib/constants";
import { generate_aum_items } from "./clients";
// import { Clients } from './clients';
// import { WlfAUM } from "./wlf-aum";
import { BillingDetails } from "./billing-details";
import {OnboardingProxyDashboard, InitOnboarding, ProcessUsers, USER_STATES} from "./onboarding-proxy-dashboard";
import {LoadTdaData} from "../../tda/actions";
import {obj_eq, deep_copy, deep_assign} from "../../../lib/js-utils";
import OnboardingUser from "../../onboarding";
import {DashboardContainer, Spinner} from "../../funcs/utils";
import {Holdings, setup_holdings_state } from "../User/holdings_card";
import {Performance} from "../User/performance_card";
import { Balances } from "../User/balances_card";
import SASecurityPurchase from "../SASecurityPurchase";
// import {WlfBreakpoints} from "./wlf-breakpoints";
import {init_lpoa, LPOADashboard} from "./LPOA-dashboard";
import AssetsUnderManagement from '../AssetsUnderManagement/AssetsUnderManagement';
import WLFUserPortfolios from '../WLF_UserPortfolios/WLF_UserPortfolios';
// import CalculatorIFrame from '../CalculatorIFrame/CalculatorIFrame';

const bannerButtons = [
  {
    label: "Users",
    id: "clients",
  },
  {
    label: "Onboarding",
    id: "onboarding",
  },
  {
    label: "Purchases",
    id: "purchases"
  },
//   {
//     label: "Calculator",
//     id: "calculator"
//   }
];

const DISPLAY_UNKNOWN= -1;
const DISPLAY_DASHBOARD = 0;
const DISPLAY_BILLING_OVERVIEW = 1;
const DISPLAY_USER = 2;
const DISPLAY_PORTFOLIO = 3;
const DISPLAY_ONBOARDING = 4;
const DISPLAY_BILLING_USER = 5;
const DISPLAY_PURCHASES = 6;
// const DISPLAY_CALCULATOR = 7;

class Wlf_View extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      page_token: null,
      advisory: null,
      sub_advisory: null,
      current: "balances",
      billing_items: [],
      user_billing: {},
      billing_page_token: null,
      show_client_menu: -1,
      client_menu_over: -1,
      onboarding_users: [],
      loading: false,
      ...InitOnboarding(this),
      ...init_lpoa(this),
      ...setup_holdings_state(),
    }
  }

  getLocation = () => {
    const path = this.props.path.split("/");
    if (path.length >= 3) {
      return path[2];
    }
    return null;
  }

  componentDidMount = () => {
    this.handleDispatch();
    this.doLoadUsers();
  };

  componentDidUpdate(prevProps) {
    this.handleDispatch(prevProps);
  }

  handleDispatch = (prevProps) => {
    const prevPath = prevProps && prevProps.path;
    const currPath = this.props.path;
    const currArgs = this.props.args;
    const prevArgs = prevProps && prevProps.args;
    const segments = currPath.split("/");

    if (prevPath !== currPath || !obj_eq(prevArgs, currArgs)) {
      const last_segment = segments[segments.length - 1];
      if (last_segment === "clients") {
        this.doLoadBillingOverview();
      } else if (last_segment === "billing") {
        this.doLoadBillingHistory();
      } else if (last_segment === "onboarding") {
        if (this.state.onboarding_users.length === 0) {
          this.doLoadProxyOnboarding();
        }
        if (this.state.lpoa_items.length === 0) {
          this.loadLPOAItems();
        }
      } else if (segments.length >= 3 && segments[2].startsWith("onboarding_")) {
        if (this.state.onboarding_users.length === 0) {
          this.doLoadProxyOnboarding();
        }
      } else if (last_segment === "user") {
        const date = new Date();
        const dateStr = sprintf("%04d%02d%02d",
          date.getFullYear(), date.getMonth(), date.getDate());
        const chart_colors = this.props.client && this.props.client.chart_colors;
        this.props.loadAccountData(
          this.props.args.username, this.props.args.acct_index, dateStr, chart_colors);

      }
    }
  }

  getOnboardingData = (username, index) => {
    const key = sprintf("%04d", index);
    return this.props.onboarding
      && this.props.onboarding[username]
      && this.props.onboarding[username][key];
  }

  doLoadBillingHistory = () => {

    const username = this.props.args.username;
    const index = this.props.args.acct_index;

    if (!username || !index) {
      // Load wlf detail

      loadBillingDetail(this.props.token, this.props.wlf_id)
        .then(results => {
          const user_billing = deep_copy(this.state.user_billing);
          deep_assign(user_billing, [this.props.wlf_id, "items"], results.items);
          this.setState({ user_billing });
        })
    } else {
      const key = sprintf("%04d", index);

      if (this.state.user_billing[username]
        && this.state.user_billing[username][key]) {
        return;
      }

      loadBillingDetail(this.props.token, this.props.wlf_id, username, index)
        .then(results => {
          const key = sprintf("%04d", index);
          const user_billing = deep_copy(this.state.user_billing);
          deep_assign(user_billing, [username],
            {
              [key]: {
                items: results.items,
                account_number: results.account_number,
              },
              name: results.name,
            });
          this.setState({ user_billing });
        })
    }

  }

  doLoadBillingOverview = () => {
    if (this.state.billing_items.length === 0) {
      this.setState({loading: true});
      loadWlfAUM(this.props.token, this.props.wlf_id, null)
        .then(result => {
          this.setState({loading: false});
          this.props.setWlfAUM(result.wlf_aum);
          this.props.setSecurityBreakpoints(result.purchase_items);
          const new_state = {};
          new_state.billing_page_token = result.page_token;
          new_state.billing_items = generate_aum_items(result, this.props.app.wlf);
          this.setState(new_state);
        })
    }
  }

  loadLPOAItems = () => {
    this.setState({ loading_lpoa: true });
    getLPOAItems(this.props.token)
      .then(items => {
        this.setState({
          loading_lpoa: false,
          lpoa_items: items,
        });
      })
  }

  doLoadProxyOnboarding = () => {
    this.setState({ onboarding_loading: true });
    loadProxyOnboarding(this.props.token, this.props.wlf_id, null)
      .then(results => {
        ProcessUsers(this, results.users);
        this.setState({
          onboarding_loading: false,
          onboarding_users: results.users,
        }, () => {
          const missing = this.getMissingAccountNumbers();
          if (missing.length > 0) {
            this.startTDATimeout(missing);
          }
        })
      })
  }

  getMissingAccountNumbers = () => {
    const missing = [];
    this.state.onboarding_users.forEach(user => {
      if (!user.account) {
        missing.push({
          username: user.username,
          identity_id: user.identity_id,
          index: user.account_index,
          confirmed: true,
        });
      }
    });
    return missing;
  }

  updateUsers = (onboarding_users, update_items) => {
    update_items.forEach(item => {
      const onboarding_user = onboarding_users.find(
        user => user.username === item.username && user.account_index === item.index);
      if (!onboarding_user) {
        console.log("Can't find", item.username, item.index);
      } else {
        onboarding_user.account = item.tda_account_number;
      }
    })
  }

  startTDATimeout = (missing_items) => {
    this.time_out = setTimeout(() => {
      LoadTdaData(this.props.token, this.props.onboarding_token, -1, missing_items)
        .then(result => {
          const current_missing = this.getMissingAccountNumbers();
          if (current_missing.length === 0) {
            delete this.time_out;
            return
          }

          if (result.items.length === 0) {
            this.startTDATimeout(current_missing);
            return;
          }

          const new_users = deep_copy(this.state.onboarding_users);
          this.updateUsers(new_users, result.items);

          this.setState({
            onboarding_users: new_users,
          }, () => {
            const new_missing = this.getMissingAccountNumbers();
            if (new_missing.length !== 0) {
              this.startTDATimeout(new_missing);
            }
          });
        })
    }, 5000);
  }


  doLoadUsers = async () => {
    // if (this.state.users.length === 0) {
    //   loadAllUsers(this.props.token, null, this.props.wlf_id)
    //     .then(({users, page_token }) => {
    //         console.log('users from load all users', users);
    //       this.setState({ users, page_token });
    //     })
    // }
    try {
        if(this.state.users.length === 0) {
            const { wlfs } = await loadAllUsers(this.props.token, null, this.props.wlf_id);
            this.setState({ wlfs: wlfs[0], wlf: wlfs[0].wlf });
        }
    } catch (error) {
        console.log(error);
    }
    
  }

  maybeLoad = async () => {
    try {
        const { wlfs } = await loadAllUsers(this.props.token, null, this.props.wlf_id);
        this.setState({ wlfs: wlfs[0], wlf: wlfs[0].wlf });
    } catch (error) {
        console.log(error)
    }

    return;
  }

  onBannerClick = banner_id => {
    const path = this.props.path.split('/');
    const current = path[2];

    if (current !== banner_id) {
      const newPath = "/" + path[1] + "/" + banner_id;
      this.props.navigatePath(newPath);
    }
  };

  maybeDumpBanner = () => {
    if (!this.props.bannerMenu) {
      return null;
    }
    const client = this.props.client;
    const banner_style = {
      paddingLeft: "7rem",
      paddingRight: "8.1rem",
    }
    return (
      <BannerMenu
        buttons={bannerButtons}
        bannerColor={getRGB(client.color.banner_background)}
        style={banner_style}
        onClick={this.onBannerClick}
        current={this.state.current}/>
    );
  };

  textStyle = () => {
    if (!this.props.css) {
      return {};
    }
    const color = this.props.css.text_color_0;
    const colorStr = sprintf(
      "rgb(%d, %d, %d", color.red, color.green, color.blue);
    return {
      color: colorStr
    }
  };

  rowProps = (state, rowInfo, column) => {
    return {
      style: this.textStyle()
    }
  };

  pathToDisplay = () => {
    if (!this.props.bannerMenu) {
      return {
        display: DISPLAY_DASHBOARD,
      };
    }

    const path = this.props.path;
    const args = this.props.args;

    if (path === this.props.rootPath && Object.keys(args).length === 0) {
      return {
        display: DISPLAY_BILLING_OVERVIEW
      };
    }

    const segments = this.props.path.split("/");

    if (segments[segments.length - 1] === "purchases") {
      return {
        display: DISPLAY_PURCHASES
      };
    }

    // if(segments.length === 3 && segments[segments.length - 1] === "calculator") {
    //     return {
    //         display: DISPLAY_CALCULATOR
    //     }
    // }

    if (segments.length === 3 && segments[2] === "user" && args.username) {
      return {
        display: DISPLAY_USER,
        username: args.username,
        index: args.acct_index,
      }
    }

    if (segments.length === 3 && segments[2] === "onboarding") {
      return {
        display: DISPLAY_ONBOARDING,
      }
    }

    if (segments.length >= 3 && segments[2].startsWith("onboarding_")) {
      return {
        display: DISPLAY_ONBOARDING,
        username: args.username,
        identity_id: args.identity_id,
        account_state: args.account_state,
        acct_index: parseInt(segments[2].split("_")[1], 10),
      }
    }

    if (segments.length === 3 && segments[2] === "billing") {
      return {
        display: DISPLAY_BILLING_USER,
        username: args.username,
        acct_index: parseInt(args.acct_index, 10),
      }
    }

    if (segments.length === 5 && segments[2] === 'portfolio') {
      return {
        display: DISPLAY_PORTFOLIO,
        user_id: segments[3],
        id: segments[4],
      }
    }

    return {
      display: DISPLAY_UNKNOWN,
    }
  };

  renderBilling = () => {
    // const wlf = this.props.app.wlf;
    // const loading = this.state.loading;
    // const do_fee_table = wlf.ui && wlf.ui.wlf && wlf.ui.wlf.fee_breakpoint_table;
    // let aum_div = do_fee_table
    //   ? (<WlfBreakpoints
    //     loading={loading}
    //     client={this.props.client}
    //     wlf={this.props.app.wlf}
    //     breakpoints={this.props.securityPurchase.breakpoints}
    //     component={this}/>)
    //   : (<WlfAUM
    //     loading={loading}
    //     client={this.props.client}
    //     component={this}/>);

    if(!this.state.wlf || !this.state.wlfs) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '24px' }}>
                <Spinner size="2rem"/>
            </div>
        )
    }

    return (
      <div style={{ paddingTop: '16px', paddingBottom: '48px' }}>
        {/* { aum_div } */}
        <AssetsUnderManagement title='WLF' wlf={this.state.wlf} />
        <WLFUserPortfolios wlf_item={this.state.wlfs} token={this.props.token} maybeLoad={this.maybeLoad} />
        {/* <Clients
          loading={loading}
          client={this.props.client}
          do_fee_table={do_fee_table}
          component={this}
          /> */}
      </div>
    )
  }

  renderBillingDetails = (username, acct_index) => {
    return (
      <BillingDetails
        component={this}
        data={this.state.user_billing}
        wlf_id={this.props.wlf_id}
        username={username}
        acct_index={acct_index}/>
    )
  }

  getUserDashboard = () => {
    const username = this.props.args.username;
    const acct_index = this.props.args.acct_index;
    const acct_key = acct_index === "-1" ? "ALL" : sprintf("%04d", acct_index);
    if (!this.props.userDashboard
      || !this.props.userDashboard[username]) {
      return null;
    }
    return this.props.userDashboard[username][acct_key];
  }


  renderUserDashboard = () => {
    if (!this.getUserDashboard()) {
      return null;
    }
    return (
      <div>
        <Balances component={this}/>
        <Holdings component={this} prm_state={this.state}/>
        <Performance component={this}/>
      </div>
    )
  }

  onEnvelopeSent = (username, index, envelope_id) => {
    const onboarding_users = deep_copy(this.state.onboarding_users);
    const user = onboarding_users.find(
      user => user.username === username && user.account_index === index);
    user.state = USER_STATES.OUT_FOR_SIGNATURE;
    this.setState({ onboarding_users });
  }

  renderOnboarding = (display) => {
    const username = display.username;
    if (username) {
      const is_loading = this.state.onboarding_loading;
      const user_missing = !(username in this.props.onboarding);
      const show_onbarding = !is_loading && !user_missing;

      const spinner = (
        <div align={"center"}>
          <Spinner size={"2rem"}/>
        </div>
      )
      return (
        <DashboardContainer
          client={this.props.client}>
          {show_onbarding && <OnboardingUser
            is_proxy={true}
            username={display.username}
            identity_id={display.identity_id}
            account_state={display.account_state}
            onEnvelopeSent={this.onEnvelopeSent}
            path={this.props.path}
            args={this.props.args}/> }
          { !show_onbarding && spinner }
        </DashboardContainer>
      )
    }
    return (
      <div>
        <LPOADashboard
          component={this}
          client={this.props.client}/>
        <OnboardingProxyDashboard
          component={this}
          client={this.props.client}
          />
      </div>
    );
  }

  renderGreeting = (display) => {
    if (this.props.username) {
      return null;
    }
    const hrs = new Date().getHours();
    const name = this.props.user.name;
    let msg;
    if (hrs < 12) {
      msg = "Good morning";
    } else if (hrs < 17) {
      msg = "Good afternoon";
    } else {
      msg = "Good evening";
    }
    const divStyle = {
      background: "#FFF",
      padding: "2rem",
      margin: "2rem",
    };
    const do_medium = this.props.app.width < DEVICE_WIDTH.large;
    const text_style = {
      fontSize: do_medium ? "1rem" : "2rem",
      fontWeight: "600",
    }
    const right_text_style = {
      fontSize: "1rem",
      fontWeight: "600",
    }
    const wlf_name = this.props.app.wlf.name;
    let onboarding_div, dashboard_div, billing_div;

    if (display.display === DISPLAY_ONBOARDING && display.username) {
      const user = this.state.onboarding_users.find(
        user => user.username === display.username && user.account_index === display.acct_index);
      if (user) {
        onboarding_div = (
          <div style={{display: "block"}}>
            <div style={text_style}>
              <span>Onboarding</span>
            </div>
            <div style={right_text_style}>
              <span>{user.name} - {user.account}</span>
            </div>
          </div>
        )
      }
    } else if (display.display === DISPLAY_USER
      && display.username
      && this.getUserDashboard()) {
      const name = this.getUserDashboard().name;
      const acct_index = this.props.args.acct_index;
      const tda_acct = this.getUserDashboard().menu_data[acct_index].account;
      dashboard_div = (
        <div style={{display: "block"}}>
          <div style={text_style}>
            <span>User Dashboard</span>
          </div>
          <div style={right_text_style}>
            <span>{name} - {tda_acct}</span>
          </div>
        </div>
      )
    } else if (display.display === DISPLAY_BILLING_USER) {
      const username = display.username;
      const key = sprintf("%04d", display.acct_index);
      const data = this.state.user_billing[username]
        && this.state.user_billing[username][key];
      if (data) {
        const name = this.state.user_billing[username].name;
        billing_div = (
          <div style={{display: "block"}}>
            <div style={text_style}>
              <span>Billing History</span>
            </div>
            <div style={right_text_style}>
              <span>{name} - {data.account_number}</span>
            </div>
          </div>
        )
      }
    }

    return (
      <div style={divStyle}>
        <div style={{display: "flex", alignItems: 'center'}}>
          <div>
            <div className="title_" style={text_style}>
              <span>{msg}{ ' - ' }{name}</span>
            </div>
          </div>
          <div style={{flex: "1"}}/>
          <div style={right_text_style}>
            <span>{wlf_name} - Admin</span>
          </div>
        </div>
        { onboarding_div }
        { dashboard_div }
        { billing_div }
      </div>
    )
  }

  render() {
    const style = this.textStyle();
    style.marginTop = "1rem";
    const display = this.pathToDisplay();

    return (
      <div>
        { this.maybeDumpBanner() }
        <div className="img-col" style={{ backgroundColor: '#fff' }}>
          <div className="page-container" style={{ backgroundColor: '#fff' }}>
            <div className="container">
              { this.renderGreeting(display) }
              { display.display === DISPLAY_BILLING_OVERVIEW && this.renderBilling() }
              { display.display === DISPLAY_USER && this.renderUserDashboard() }
              { display.display === DISPLAY_ONBOARDING && this.renderOnboarding(display) }
              { display.display === DISPLAY_BILLING_USER
                && this.renderBillingDetails(display.username, display.acct_index) }
              { display.display === DISPLAY_PORTFOLIO
                && <PortfolioDashboard portfolio_id={display.id} user_id={display.user_id}/> }
              { display.display === DISPLAY_PURCHASES
                && <SASecurityPurchase/> }
              {/* { display.display === DISPLAY_CALCULATOR && <CalculatorIFrame />}  */}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { Wlf_View };
